import { createDrawerStore } from '../drawer/createDrawerStore';

export const useVehicleDrawerStore = createDrawerStore();
